import { c as _c } from "react/compiler-runtime";
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { PRODUCT_BASIC_DETAILS } from '../queries';
import useProductBasicQueryOptions from './useProductBasicQueryOptions';
const useProductBasicDetails = (id, slug, t0, t1) => {
  const $ = _c(16);
  let t2;
  if ($[0] !== t0) {
    t2 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const queryOptions = t2;
  let t3;
  if ($[2] !== t1) {
    t3 = t1 === undefined ? {
      skip: false
    } : t1;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const hookOptions = t3;
  let t4;
  if ($[4] !== hookOptions || $[5] !== id || $[6] !== queryOptions || $[7] !== slug) {
    t4 = {
      id,
      slug,
      queryOptions,
      hookOptions
    };
    $[4] = hookOptions;
    $[5] = id;
    $[6] = queryOptions;
    $[7] = slug;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const options = useProductBasicQueryOptions(t4);
  const {
    loading,
    error,
    data,
    refetch
  } = useSuspenseQuery(PRODUCT_BASIC_DETAILS, options);
  const t5 = loading || options.skip || !data;
  const t6 = data?.basicDetails;
  let t7;
  if ($[9] !== data || $[10] !== error || $[11] !== loading || $[12] !== refetch || $[13] !== t5 || $[14] !== t6) {
    t7 = {
      loading: t5,
      error,
      data: t6,
      rawLoading: loading,
      rawData: data,
      refetch
    };
    $[9] = data;
    $[10] = error;
    $[11] = loading;
    $[12] = refetch;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default useProductBasicDetails;